import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiSvgIcon from '@material-ui/core/SvgIcon';

import units from 'ha/theme/units';

type MuiSvgIconProps = import('@material-ui/core/SvgIcon').SvgIconProps;

interface OwnProps {
  color?: MuiSvgIconProps['color'] | 'mint' | 'default';
  fontSize?: MuiSvgIconProps['fontSize'] | 'sm' | 'xs';
}

export type SvgIconProps = Omit<MuiSvgIconProps, 'color' | 'fontSize'> &
  OwnProps;

const useStyles = makeStyles(theme => ({
  'color-mint': {
    color: theme.palette.mint.main,
  },
  'color-default': {
    color: theme.palette.grey[700],
  },
  'fontSize-xs': {
    fontSize: units.rem(0.5),
  },
  'fontSize-sm': {
    fontSize: units.rem(1),
  },
}));

const SvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color, fontSize, className, ...rest }, ref) => {
    const classes = useStyles();

    return (
      <MuiSvgIcon
        {...rest}
        className={cx(
          className,
          classes[`color-${color}`],
          classes[`fontSize-${fontSize}`],
        )}
        color={color !== 'mint' && color !== 'default' ? color : undefined}
        fontSize={fontSize !== 'xs' && fontSize !== 'sm' ? fontSize : undefined}
        ref={ref as React.RefObject<SVGSVGElement>}
      />
    );
  },
);

export default React.memo(SvgIcon);
